import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import { getPlural } from 'client/utils/plural';
import { getNewAlertsCountStatePath } from 'site-modules/shared/components/profile/price-drop-alerts/alerts-utils';

function PriceDropAlertsBannerComponent({ className = null, newAlertsCount = 0 }) {
  if (!newAlertsCount) {
    return null;
  }

  return (
    <span className={className}>
      {newAlertsCount} {`${getPlural('car', newAlertsCount)} dropped in price!`}
    </span>
  );
}

PriceDropAlertsBannerComponent.propTypes = {
  className: PropTypes.string,
  newAlertsCount: PropTypes.number,
};

export const propsAreEqual = (prevProps, nextProps) => nextProps.newAlertsCount <= prevProps.newAlertsCount;

const mapStateToProps = state => ({
  newAlertsCount: get(state, getNewAlertsCountStatePath(), 0),
});

export const PriceDropAlertsBanner = connect(mapStateToProps)(
  React.memo(PriceDropAlertsBannerComponent, propsAreEqual)
);
